require('../_globals');

$('#forgotPassword').nosForm({
    fields: [
        {
            type: 'html',
            element: '<div class="alert alert-info">Please enter your email address in the box below. We will then send you instructions on how to change your password.</div><hr>',
        },
        {
            name: 'email',
            type: 'email',
            label: 'Enter your email address',
            required: true,
            maxlength: 60,
        },
        {
            name: 'resetpassword',
            type: 'submit',
            classname: 'btn btn-primary btn-block btn-lg',
            value: 'Reset Password',
        },
    ],
    ajax: false,
});

$('#newPassword').nosForm({
    fields: [
        {
            name: 'loginsid',
            type: 'hidden',
            value: $('#newPassword').data('loginsid'),
        },
        {
            name: 'password',
            type: 'password',
            minlength: 8,
            maxlength: 30,
            required: true,
            label: 'Enter New Password',
            messages: {
                invalid: 'Your passwords don\'t match!',
                required: 'A password is required!',
            },
        },
        {
            name: 'password2',
            type: 'password',
            match: 'password',
            minlength: 8,
            maxlength: 30,
            required: true,
            label: 'Repeat New Password',
            messages: {
                invalid: 'Your passwords don\'t match!',
                required: 'You must repeat your password!',
            },
        },
        {
            name: 'submit',
            type: 'submit',
            value: 'Reset Password',
            classname: 'btn btn-primary',
            formGroup: true,
        },
    ],
    ajax: false,
});
